import React, {Component, Fragment} from 'react';
import {Provider} from 'react-redux';
import jwt_decode from 'jwt-decode';
import {Helmet} from 'react-helmet';
import {MuiThemeProvider} from '@material-ui/core/styles';
import setAuthToken from '../features/Auth/utils/setAuthToken';
import {setCurrentUser} from '../features/Auth/actions';
import store from './redux/configureStore';
import Main from './Main';
import {CookiesProvider} from 'react-cookie';
import {LocalizeProvider} from 'react-localize-redux';
import {theme} from '../features/Layout';
import '../features/Layout/assets/scss/main.css';

// Check for the authentication token (JWT)
if (localStorage.jwtToken) {
    // Set the token to the Auth header
    setAuthToken(localStorage.jwtToken);

    // Decode the JWT token to get user data
    const decoded = jwt_decode(localStorage.jwtToken);

    // Set the current user
    store.dispatch(setCurrentUser(decoded));
}

class App extends Component {
    render() {
        const siteTitle = process.env.REACT_APP_SITE_TITLE;
        const primaryColor = process.env.REACT_APP_THEME_PRIMARY_COLOR;

        return (
            <CookiesProvider>
                <MuiThemeProvider theme={theme}>
                    <Provider store={store}>
                        <LocalizeProvider store={store}>
                            <Fragment>
                                <Helmet>
                                    <title>{siteTitle}</title>
                                    <meta name="theme-color" content={primaryColor} />
                                </Helmet>
                                <Main/>
                            </Fragment>
                        </LocalizeProvider>
                    </Provider>
                </MuiThemeProvider>
            </CookiesProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js